const ExportTypes = {
  condensed: {
    key: 'condensed',
    description: 'misc.printEntitiesTable',
  },
  expanded: {
    key: 'expanded',
    description: 'misc.oneEntity',
  },
  image: {
    key: 'image',
    description: 'misc.imageExport',
  },
  json: {
    key: 'json',
    description: 'misc.jsonDescription',
  },
};

export default ExportTypes;
